import { Injectable } from '@angular/core';
import { HttpService } from '../http/http.service';
import { SaleInvoice, SaleInvoiceHashResponse, SaleInvoiceRequest } from '../../interface/product/salesinvoice/salesinvoice';
import { firstValueFrom, Observable } from 'rxjs';
import { toDateParam } from 'src/app/utils';

@Injectable({
  providedIn: 'root'
})
export class SaleInvoiceService {

  constructor(private _http: HttpService) { }
  public get(id: number): Promise<any> {
    return firstValueFrom(this._http.get('/SaleInvoices/' + id))
  }
  public getByHash(hash: string): Promise<SaleInvoiceHashResponse> {
    return firstValueFrom(this._http.get('/SaleInvoices/Hash/' + hash))
  }

  getRaw(id: number): Promise<any> {
    return firstValueFrom(this._http.get(`/SaleInvoices/${id}/raw`))
  }
  getAll({ number = 0, size = -1, dateFrom, dateTo }: { number?: number, size?: number, dateFrom?: Date, dateTo?: Date } | undefined = {}): Promise<any> {
    return firstValueFrom(this._http.get(`/SaleInvoices?number=${number}&size=${size}&dateFrom=${toDateParam(dateFrom)}&dateTo=${toDateParam(dateTo)}`));
  }
  create(data: SaleInvoiceRequest): Promise<any> {
    return firstValueFrom(this._http.post('/SaleInvoices', data));
  }
  public update(id: number, data: SaleInvoiceRequest): Promise<SaleInvoice> {
    return firstValueFrom(this._http.put('/SaleInvoices/', id, data));
  }
  search(data: any): Promise<any> {
    return firstValueFrom(this._http.post('/SaleInvoices/Search', data));
  }


  // onSubmit(){
  //   return this._httpSalesInvoice.post('/SalesInvoice',JSON.stringify({

  //   }))
  // }
  getCustomerInvoices(id: number) {
    return this._http.get('/SaleInvoices/payments/' + id)
  }
  updateProductRecord(id: number, data: SaleInvoice) {
    return this._http.put('/SaleInvoices/', id, data);
  }
  public async void(id: number): Promise<any> {
    return firstValueFrom(this._http.post('/SaleInvoices/' + id + '/void', null));
  }

  public getPdf(id: number, templateId?: number): Promise<Blob> {
    const query = templateId != null ? `?templateId=${templateId}` : '';
    return firstValueFrom(this._http.getBlob(`/SaleInvoices/${id}/pdf${query}`));
  }

}
